/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-undef */
/* eslint-disable jsx-a11y/img-redundant-alt */
/* eslint-disable no-unused-vars */

import { openDialog } from "../../redux/slice/dialogueSlice";
import { getPayout } from "../../redux/slice/payoutSlice";
import { warning } from "../../util/Alert";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Title from "../extras/Title";
import Button from "../extras/Button";
import Table from "../extras/Table";
import Pagination from "../extras/Pagination";
import Analytics from "../extras/Analytics";
import moment from "moment";
import { useNavigate } from "react-router-dom";
import { getAllWalletHistory } from "../../redux/slice/salarySlice";
import Sign from "../../assets/images/sign.png"
import With from "../../assets/images/with.png"
import { ReactComponent as Refund } from "../../assets/icon/refund.svg"
const StaffEarning = () => {
  const { allExpert, total } = useSelector((state) => state.salary);
  const { setting } = useSelector((state) => state.setting)

  const [data, setData] = useState([]);
  const [startDate, setStartDate] = useState("ALL");
  const [endDate, setEndDate] = useState("ALL");
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [page, setPage] = useState(0);
  const [transactionType, setTransactionType] = useState("All");
  const transactionTypeData = [
    { value: "1", label: "Credit" },
    { value: "2", label: "Debit" }
  ]
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event, 10));
    setPage(0);
  };
  useEffect(() => {
    const payload = {
      startDate: startDate === "ALL" ? "All" : startDate,
      endDate: endDate === "ALL" ? "All" : endDate,
      start: page,
      limit: rowsPerPage,
      type: transactionType
    }
    dispatch(getAllWalletHistory(payload));
  }, [startDate, page, transactionType, rowsPerPage]);
  useEffect(() => {
    setData(allExpert);
  }, [allExpert]);

  const dispatch = useDispatch();

  const mapData = [
    {
      Header: "No",
      Cell: ({ index }) => <span>{page * rowsPerPage + parseInt(index) + 1}</span>
    },

    {
      Header: "UniqueId",
      Cell: ({ row }) => (
        <span className="text-capitalize">{row?.uniqueId || "-"}</span>
      ),
    },
    {
      Header: "Expert Info",
      Cell: ({ row }) => (
        <span className="text-capitalize">{row?.expert?.name || "-"}</span>
      ),
    },
    {
      Header: `Amount (${setting?.currencySymbol || "$"})`,
      Cell: ({ row }) => <span className="text-capitalize">{row?.amount || "-" + (setting?.currencySymbol || "$")}</span>,
    },
    {
      Header: `Date`,
      Cell: ({ row }) => (
        <span className="text-capitalize">{row?.date || "-"}</span>
      ),
    },
    {
      Header: "Time",
      Cell: ({ row }) => (
        <span className="text-capitalize">
          {row?.time ? row?.time : "-"}
        </span>
      ),
    },

    {
      Header: 'Transaction Type',
      Cell: ({ row }) => {
        const isCredit = row?.type === 1;
        const isDebit = row?.type === 2 && row?.payoutStatus === 2;

        return isCredit ? (
          <button className=" badge-success" >
            Credit
          </button>
        ) : isDebit ? (
          <button className=" badge-danger" >
            Debit
          </button>
        ) : (
          <button className="badge-warning" >
            Pending
          </button>
        );
      },
    },
    {
      Header: 'Transaction Completed',
      Cell: ({ row }) => {
        const isCredit = row?.type === 1;
        const isDebit = row?.type === 2;

        return isCredit ? (

          <button className="badge-success"
            >
            
            Booking Complete  
          </button>
        ) : isDebit ? (
          <>
            {row?.payoutStatus === 1 ? (
              <button className="badge-warning"
                >
                
                {
                  row?.payoutStatus === 1 && "Withdraw Pending" || row?.payoutStatus === 2 && "Withdraw Approve" || row?.payoutStatus === 3 && "Withdraw Declined"
                }
              </button>
            ) : (
              <button className="badge-danger"
                >
                
               {
                  row?.payoutStatus === 1 && "Withdraw Pending" || row?.payoutStatus === 2 && "Withdraw Approve" || row?.payoutStatus === 3 && "Withdraw Declined"
                }
              </button>
            )
            }
          </>
        ) : (
          ""
        );
      },
    },
  ];

  return (
    <div className="userPage">
    <div className="d-flex justify-content-end mb-3">
       <Analytics
            analyticsStartDate={startDate}
            analyticsStartEnd={endDate}
            placeholder="Wallet"
            analyticsStartDateSet={setStartDate}
            analyticsStartEndSet={setEndDate}
          />
    </div>
    <div className="user-table mb-3">
    <div className="user-table-top">
          <div className=" d-flex justify-content-between align-items-center w-100 ">
            <div className="w-100">
              <h5
                className="main-title">
                Expert earnings
              </h5>
            </div>
            <div className="d-flex gap-2 justify-content-end w-100">
              <div className="inputData w-25">
          
          <select
            name="transactionType"
            className="form-select"
            id="transactionType"
            value={transactionType}
            onChange={(e) => {
              console.log("eeeeee", e)
              const selectedSalonId = e.target.value;
              const payload = {
                startDate: startDate === "ALL" ? "All" : startDate,
                endDate: endDate === "ALL" ? "All" : endDate,
                start: page,
                limit: rowsPerPage,
                type: transactionType
              }
              setTransactionType(selectedSalonId);
              dispatch(getAllWalletHistory(payload));
            }}
          >
            <option key="All" value="All">
              All
            </option>
            {transactionTypeData?.map((data) => (
              <option key={data?.value} value={data?.value}>
                {data?.label}
              </option>
            ))}
          </select>
        </div>
            </div>
          </div>
    </div>
      
        <Table
          data={data}
          mapData={mapData}
          rowsPerPage={rowsPerPage}
          Page={page}
        />
        <Pagination
          type={"server"}
          serverPage={page}
          setServerPage={setPage}
          serverPerPage={rowsPerPage}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
          totalData={total}
        />
      
    </div>
    </div>
  );
};

export default StaffEarning;
